import React from 'react'
import styled from 'styled-components'
import {Box, IconButton} from '@miro-site/core'
import theme from './theme'

export type Item = {
  title: string
  path: string
}

interface FooterSocialProps {
  items: Item[]
}

/* Social buttons */
import {Twitter, Facebook, LinkedIn, Instagram, Youtube} from '@miro-site/core'

const icons = {
  Twitter: <Twitter />,
  Facebook: <Facebook />,
  LinkedIn: <LinkedIn />,
  Instagram: <Instagram />,
  Youtube: <Youtube />,
}

const Social = styled(Box).attrs({
  as: 'ul',
  $styles: {
    display: 'flex',
    justifyContent: ['center', 'center', '', '', ''],
  },
  $mt: theme.footer.social.margin.top,
  $mb: theme.footer.social.margin.bottom,
})``

const SocialItem = styled(Box).attrs({
  as: 'li',
  $ml: theme.footer.socialItem.margin.left,
})`
  &:first-child {
    margin-left: 0;
  }
`

const IconLink = styled(IconButton)`
  path {
    ${({theme}) =>
      theme.normalizeStyles({
        transition: `fill ease ${theme.animation.transitionDuration}`,
      })}
  }
  &:hover path {
    ${({theme}) =>
      theme.normalizeStyles({
        fill: theme.colors.outspoken,
      })}
  }
`

const FooterSocial = (props: FooterSocialProps): React.ReactElement => {
  const {items} = props

  return (
    <Social>
      {items.map((item, index) => {
        return (
          <SocialItem key={index}>
            <IconLink
              icon={icons[item.title]}
              label={item.title}
              href={item.path}
              title={item.title}
            />
          </SocialItem>
        )
      })}
    </Social>
  )
}

export default FooterSocial
